import type { PickupPointPaymentMethod } from '@/shared/api/pickupPoint';

export const formatPaymentMethod = (methods: PickupPointPaymentMethod[]): string[] => {
    const hasCardOnReceipt = methods.includes('card_on_receipt');
    const hasCashOnReceipt = methods.includes('cash_on_receipt');
    const hasAlreadyPaid = methods.includes('already_paid');
    const variants: string[] = [];

    if (hasCardOnReceipt && hasCashOnReceipt) {
        variants.push('Картой или наличными при получении');
    } else {
        if (hasCardOnReceipt) {
            variants.push('Картой при получении');
        }

        if (hasCashOnReceipt) {
            variants.push('Наличными при получении');
        }
    }

    if (hasAlreadyPaid) {
        variants.push('Оплата онлайн');
    }

    return variants;
};
